import React from 'react'
import frogImage from '../../assets/landing/about-frog.svg'
import './landing.css'

const About = () => {
  return (
    <div
      className="w-full bg-no-repeat about-bg bg-cover pb-[200px] z-0"
      id="about"
    >
      <div className="w-full md:grid lg:grid-cols-5">
        <div className="col-span-2 pt-10 md:pt-[250px] md:pl-[90px] w-full flex md:block items-center justify-center">
          <img src={frogImage} alt="" className="w-[212px] md:w-auto" />
        </div>
        {/* <div className="about-stand-bg bg-center pt-12 max-w-[824px] w-full relative h-[460px] md:h-[1000px] col-span-3 bg-contain bg-no-repeat">
          <div className="about-cont max-w-[275px] md:max-w-[464px] xl:max-w-[664px] w-full font-sourGummy mx-auto  absolute top-[115px] md:top-[270px] left-[30px]  md:left-[80px]">
            <h2 className="about-title text-[28px] sm:text-[32px] xl:text-[88px] uppercase hero-text">
              <span className="text-black">About</span>{' '}
              <span className="text-[#006C28]">$Lilpepe</span>
            </h2>

            <p className="about-desc text-[10px] md:text-sm xl:text-2xl w-full text-wrap">
              The next evolution of meme coins.Little Pepe is a Layer 2
              blockchain engineered for speed, security, ultra-low fees—and
              powered by memes.
            </p>
            <p className="about-desc text-[10px] md:text-sm xl:text-2xl text-wrap">
              At the heart of the ecosystem lies $LILPEPE, the utility token
              fueling every corner of the Pepe Unchained network. You're still
              early—just in time to witness the rise of a new golden era for
              meme coins, with Pepe reigning supreme as King and Little Pepe
              Layer 2 as his unstoppable kingdom.
            </p>
          </div>
        </div> */}

        <div className="about-stand-bg bg-center pt-12 max-w-[824px] w-full relative h-[460px] md:h-[1000px] col-span-3 bg-contain bg-no-repeat">
          <div className="max-w-[275px] md:max-w-[464px] xl:max-w-[664px] w-full font-sourGummy mx-auto lg:absolute top-[115px] lg:top-[270px] left-[30px]  md:left-[80px] about-cont">
            <h2 className="text-[28px] sm:text-[32px] xl:text-[88px] uppercase hero-text about-title">
              <span className="text-black">About</span>{' '}
              <span className="text-[#006C28]">$Lilpepe</span>
            </h2>

            <p className="text-[10px] xl:text-2xl w-full text-wrap about-desc">
              The next evolution of meme coins.Little Pepe is a Layer 2
              blockchain engineered for speed, security, ultra-low fees—and
              powered by memes.
            </p>
            <p className="text-[10px] xl:text-2xl text-wrap about-desc">
              At the heart of the ecosystem lies $LILPEPE, the utility token
              fueling every corner of the Pepe Unchained network. You're still
              early—just in time to witness the rise of a new golden era for
              meme coins, with Pepe reigning supreme as King and Little Pepe
              Layer 2 as his unstoppable kingdom.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default About
